import React from "react";
import fbLogo from "../../img/fb.svg";
// import twitterLogo from "./img/twitter.svg";
import instagramLogo from "../../img/instagram.svg";
import "./footer.css"

export default class Footer extends React.Component {
  render() {
    return (
      <footer className='u-footer'>
        <p className='footer__texto'>
          Todos los derechos reservados Agua y Saneamientos
          Argentinos S.A. 
          <a
            target='_blank'
            href='https://www.aysa.com.ar/Terminos_y_condiciones'
            rel='noreferrer'
            className='footer__terminos u-active-none u-border-none u-btn u-button-style u-hover-none u-none u-text-palette-1-base u-btn-1'
          >
             Términos y condiciones de utilización del sitio
          </a>
        </p>
      </footer>
    );
  }
}
